import {
  styled,
  TableCell,
} from "@mui/material";
import TooltipCell from "controls/global/stewart-table/TooltipCell";
import React from "react";
import {
  borderSize,
  colors,
  fontSize,
  fontWeight,
  padding,
} from "theme/defaultStyle";

const StyledTableFooterCell = styled(TableCell)({
  borderBottom: "none",
  borderTop: `${borderSize.xsmall} solid ${colors.black}`,
  color: "black",
  fontSize: fontSize.large,
  fontWeight: fontWeight.bold1,
  maxWidth: "170px",
  overflow: "hidden",
  paddingRight: padding.large1,
  paddingTop: padding.small2,
  textOverFlow: "ellipses",
  "&.normalPadding": {
    paddingBottom: padding.xsmall1,
    paddingTop: padding.small2,
  },
  "&.bigPadding": {
    paddingBottom: padding.large1,
    paddingTop: padding.large1,
  },
});

const AgentRetentionTotalCell = styled(TooltipCell)({
  "&.totalDueNoUnderline": {
    color: colors.grey11,
    display: "inline-block",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "&.totalDueWhiteUnderline": {
    borderBottom: "none !important",
    display: "inline-block",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

type Props = {
  agentRetentionTotal: string;
  hasIssuedProducts: boolean;
  hasFileLockedWithUpdateablePricingItem: boolean;
};

export default function AgentRetentionTotal({ agentRetentionTotal, hasIssuedProducts, hasFileLockedWithUpdateablePricingItem }: Props) {

  const footerCellClassname = hasFileLockedWithUpdateablePricingItem
    ? "normalPadding"
    : "bigPadding";

  const totalClassname = hasFileLockedWithUpdateablePricingItem
    ? "totalDueNoUnderline"
    : "totalDueWhiteUnderline";

  return (
    <StyledTableFooterCell
      align="right"
      className={footerCellClassname}
    >
      {hasIssuedProducts &&
        <AgentRetentionTotalCell
          className={totalClassname}
          title={agentRetentionTotal}
        />
      }
    </StyledTableFooterCell>
  );
}
